import { SubmitHandler } from "react-hook-form";
import { useState } from "react";
import { useApiMutation } from "../../../../../common/infrastructure/hooks/useApiMutation";
import { IWorkingHoursData } from "../models/models";
import { useWorkingHoursForm } from "./useWorkingHoursForm";
import { IWorkingHoursFormModel } from "../validation/workingHoursValidation";

interface IUseWorkingHoursDialogProps {
  submitEndpoint: string;
  invalidateKeys: string[][];
  onSuccess?: () => void;
  workingHoursData?: IWorkingHoursData;
}

export const useWorkingHoursDialog = ({
  submitEndpoint,
  invalidateKeys,
  onSuccess,
  workingHoursData,
}: IUseWorkingHoursDialogProps) => {
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const { mutateAsync } = useApiMutation();

  const { form, fieldArrays, addTimeSlot, removeTimeSlot } =
    useWorkingHoursForm(workingHoursData);

  // Custom submit handler
  const handleSubmit: SubmitHandler<IWorkingHoursFormModel> = async (data) => {
    setIsSubmitLoading(true);

    // Transform form data back to IWorkingHoursData format for API
    const apiData: IWorkingHoursData = {
      studioId: data.studioId,
      userId: data.userId,
      days: [
        { dayOfWeek: 1, slots: data.monday },
        { dayOfWeek: 2, slots: data.tuesday },
        { dayOfWeek: 3, slots: data.wednesday },
        { dayOfWeek: 4, slots: data.thursday },
        { dayOfWeek: 5, slots: data.friday },
        { dayOfWeek: 6, slots: data.saturday },
        { dayOfWeek: 0, slots: data.sunday },
      ].filter((day) => day.slots.length > 0), // Only include days with slots
    };

    try {
      await mutateAsync(
        {
          endpoint: submitEndpoint,
          globalIsLoading: false,
          method: "post",
          invalidateKeys,
          ...apiData,
        },
        {
          onSuccess: () => {
            onSuccess?.();
          },
        }
      );
    } catch (error) {
      // Error handling is done by useApiMutation
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return {
    form,
    fieldArrays,
    addTimeSlot,
    removeTimeSlot,
    handleSubmit,
    isSubmitLoading,
  };
};
